<template>
  <div class="limiter">
		<div class="container-login100" style="background-image: url('../img/bg-01.jpg');">
			<div class="wrap-login100">
					<span class="login100-form-logo">
						<img style="height: 38px; width: 100px;" src="@/assets/asw/asw-logo.png" alt="">
					</span>

					<span class="login100-form-title p-b-34 p-t-27">
						Log in
					</span>

					<div class="wrap-input100 validate-input" data-validate = "Enter username">
						<input v-model="email" class="input100" type="text" name="username" placeholder="Username">
						<span class="focus-input100" data-placeholder="&#xf207;"></span>
					</div>

					<div class="wrap-input100 validate-input" data-validate="Enter password">
						<input v-model="pin" class="input100" type="password" name="pass" placeholder="Password">
						<span class="focus-input100" data-placeholder="&#xf191;"></span>
					</div>
<!-- 
					<div class="contact100-form-checkbox">
						<input class="input-checkbox100" id="ckb1" type="checkbox" name="remember-me">
						<label class="label-checkbox100" for="ckb1">
							Remember me
						</label>
					</div> -->

					<div class="container-login100-form-btn">
						<button class="login100-form-btn" @click="login">
							Login
						</button>
					</div>

					<div class="text-center pt-4" style="color:yellow" v-if="fail">
						{{errorMessage}}
					</div>

					<div class="text-center p-t-90">
						<!-- <a class="txt1" href="#"> -->
							<!-- Forgot Password? -->
						<!-- </a> -->
					</div>
			</div>
		</div>
	</div>
</template>

<script lang="ts" src="./Login.ts"/>